import { Directive, HostBinding, Input } from '@angular/core';

import { DATA_TYPE } from '@ib-shared/types/data.type';

@Directive({
  selector: '[ibTableHeadCellAllignment]',
})
export class TableHeadCellAllignmentDirective {
  @Input() ibTableHeadCellAllignmentType: DATA_TYPE;
  @HostBinding('class') get classes(): string {
    return 'ib-table-cell-content--' + this.ibTableHeadCellAllignmentType;
  }
}
